export default __webpack_public_path__ + "static/media/like.889cc123.svg";